const isPresent = (value) => value !== undefined && value !== null && String(value).trim() !== '';

const formatName = (patient, fallbackName = '') => {
  const firstName = patient?.first_name || '';
  const lastName = patient?.last_name || '';
  const name = `${firstName} ${lastName}`.trim();
  return name || fallbackName || '';
};

const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) {
    return '';
  }

  const birthDate = new Date(dateOfBirth);
  if (Number.isNaN(birthDate.getTime())) {
    return '';
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const birthdayPassed =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

  if (!birthdayPassed) {
    age -= 1;
  }

  return age >= 0 ? String(age) : '';
};

export const buildReportPatientInfo = ({ patient, visit, report } = {}) => {
  const patientInfo = {};
  const fallbackName = report?.patient_name && report.patient_name !== 'Unknown Patient'
    ? report.patient_name
    : '';
  const name = formatName(patient, fallbackName);
  const age = isPresent(patient?.age) ? String(patient.age) : calculateAge(patient?.date_of_birth);
  const gender = patient?.gender || '';

  if (isPresent(name)) {
    patientInfo.name = name;
  }
  if (isPresent(age)) {
    patientInfo.age = age;
  }
  if (isPresent(gender)) {
    patientInfo.gender = gender;
    patientInfo.sex = gender;
  }
  if (isPresent(visit?.patient_id)) {
    patientInfo.patient_id = visit.patient_id;
  } else if (isPresent(patient?.id)) {
    patientInfo.patient_id = patient.id;
  }
  if (isPresent(report?.visit_id)) {
    patientInfo.visit_id = report.visit_id;
  } else if (isPresent(visit?.id)) {
    patientInfo.visit_id = visit.id;
  }
  if (isPresent(report?.clinic_id)) {
    patientInfo.clinic_id = report.clinic_id;
  } else if (isPresent(visit?.clinic_id)) {
    patientInfo.clinic_id = visit.clinic_id;
  }
  if (isPresent(visit?.visit_type)) {
    patientInfo.visit_type = visit.visit_type;
  } else if (isPresent(report?.visit_type)) {
    patientInfo.visit_type = report.visit_type;
  }

  return patientInfo;
};

